import { jsx as _jsx } from "react/jsx-runtime";
import { PusherEventName } from 'anchor-scout-common/types';
import { useClientSummaryDetail } from '~/hooks/reactQuery/queries/useClientSummaryDetail';
import { useBusinessChannelEvent } from '~/pusher/useBusinessChannelEvent';
import { withDetailStatus, withSavedClientDetail } from './ClientDetailPage.utils';
import { ClientDetailPageView } from './ClientDetailPageView';
export function ClientDetailPage(param) {
    let { clientId } = param;
    const detail = useClientSummaryDetail(clientId, {
        refreshOnHookMount: true
    });
    useBusinessChannelEvent({
        eventName: PusherEventName.ClientSummaryUpdated,
        source: 'scout',
        callback: (param)=>{
            let { customerId } = param;
            if (customerId === clientId) detail.refresh();
        }
    });
    return /*#__PURE__*/ _jsx(ClientDetailPageView, {
        clientId: clientId,
        detail: detail,
        onArchiveOrRestoreSucceeded: (param)=>{
            let { status } = param;
            return detail.optimisticUpdate(withDetailStatus(status));
        },
        onClientSaved: (saved)=>detail.optimisticUpdate(withSavedClientDetail(saved))
    });
}
